function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './APSelect.css';
var InnerSelect = function InnerSelect(props) {
  var input = props.input,
    meta = props.meta,
    classModifiers = props.classModifiers,
    customClass = props.customClass,
    info = props.info,
    label = props.label,
    onSelect = props.onSelect,
    showTriangles = props.showTriangles,
    options = props.options,
    passedProps = _objectWithoutProperties(props, ['input', 'meta', 'classModifiers', 'customClass', 'info', 'label', 'onSelect', 'showTriangles', 'options']);
  var baseClasses = getBEMClasses(['ap-select', customClass]);
  return React.createElement('div', {
    className: 'form-group ' + baseClasses('select-wrapper', classModifiers)
  }, React.createElement('label', {
    className: 'ap--label ' + baseClasses('select-label')
  }, label), showTriangles ? React.createElement('div', {
    className: baseClasses('triangles-container')
  }, React.createElement('span', {
    className: 'triangle-up'
  }), React.createElement('span', {
    className: 'triangle-down'
  })) : '', React.createElement('select', Object.assign({
    className: 'form-control ' + baseClasses('select')
  }, input, passedProps, {
    onChange: function onChange(e) {
      if (onSelect) onSelect(e.target.value);
      input && input.onChange(e);
    }
  }), options.map(function (i) {
    return React.createElement('option', {
      key: i.value,
      value: i.value,
      disabled: i.disabled
    }, i.label);
  })), React.createElement('small', {
    className: 'form-text-muted ' + baseClasses('select-info')
  }, info), meta && meta.dirty && meta.error && React.createElement('span', {
    className: baseClasses('select-error')
  }, meta.error));
};
export { InnerSelect };
var APSelect = function APSelect(props) {
  return React.createElement(Field, Object.assign({
    name: props.name,
    component: InnerSelect
  }, props));
};
APSelect.defaultProps = {
  name: '',
  label: '',
  classes: 'input',
  customClass: 'custom-select',
  classModifiers: '',
  info: '',
  autoFocus: '',
  disabled: false,
  multiple: false,
  required: false,
  options: []
};
APSelect.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  classes: PropTypes.string,
  customClass: PropTypes.string,
  classModifiers: PropTypes.string,
  info: PropTypes.string,
  autoFocus: PropTypes.string,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  required: PropTypes.bool
};
export default APSelect;